<template>
  <div>
    <div class='wrapper'>
      <div class='graph'>

        <div
          v-for='(o, i) in bars' :key='i'
          class='bar'
          :style='{
            height: `${graphH-30*(10-o.value)}px`,
            background: o.color[0],
            "box-shadow": `0px 4px 40px 0px ${o.color[1]}`,
          }'
          :name='o.label'
          :value='o.valueLabel || o.value'
        >

        </div>

      </div>
      <!-- <div class='y-axis-notation'>
        <div v-for='(item, i) in yAxisIndexes' v-bind:key='i' v-bind:value='item'></div>
      </div> -->
    </div>

    <ul class="legend">
      <li
        v-for='(text,i) in legend' v-bind:key='i'
        class='legend-item'
      >
        <div
          class='box'
          :style='{
            background: bars[i].color[0],
            "box-shadow": `0px 4px 40px 0px ${bars[i].color[1]}`,
          }'
        ></div>
        {{text}}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BarGraph from './BarGraph'

export default {
  name: 'ResultSlide',
  props: [
    'bars',
    'legend'
  ],
  data() {
    return {
      yAxisIndexes: [10,8,6,4,2,0],
      graphH: 280,
      graphOnePartH: this.graphH / Math.max(this.yAxisIndexes),
    }
  },
  computed: {
    ...mapState({
    secondQuizResult: state => state.secondQuizResult
  })},
  components: {
    BarGraph
  },
};
</script>

<style scoped lang='scss'>
@import '../css/var.scss';

$graphHeight: 280px;

.wrapper {
  position: relative;
  margin-top: 50px;
  margin-bottom: 80px;

  @media (max-width: $mobile) {
    margin-bottom: 30px;
  }
}

.graph {
  height: $graphHeight;
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  box-sizing: border-box;
  z-index: 10;
  padding: 0 15px;
  border-bottom: 1px solid rgba(0,0,0,.1);

  @media (max-width: $mobile) {
    padding: 0 5px;
  }
}

.y-axis-notation {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: $graphHeight;
  position: absolute;
  top: 0;
  z-index: 9;
}

.y-axis-notation div {
  margin: 0;
  position: relative;
  height: 1px;

  &:before {
    content: attr(value);
    display: inline-block;
    position: absolute;
    top: -9px;
  }

  &:after {
    content: '';
    width: 100%;
    height: 1px;
    background-color: rgba(0, 255, 175, 0.1);
    display: inline-block;
    position: absolute;
    top: 0;
    margin-left: 25px;
  }
}

.bar {
  position: relative;
  width: 40px;
  // background: linear-gradient(#00E58F, #009AD0);
  background: linear-gradient(#02D27F, #02D27F);
  font-family: $mainFont;

  &:before {
    content: attr(value);
    display: inline-block;
    min-width: 300%;
    position: absolute;
    top: -39px;
    left: -100%;
    text-align: center;
    font-weight: bold;
  }

  &:after {
    content: attr(name);
    display: inline-block;
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translate3d(-50%,0,0);
    height: 20px;
    text-align: center;
    line-height: 1;
    font-size: 16px;

    @media (max-width: 700px) {
      visibility: hidden;
    }
  }
}


.legend {
  padding-left: 25px;
  list-style: none;

  &-item {
    position: relative;
    margin-bottom: 12px;

    font-size: 16px;
    line-height: 1.7;
    color: rgba(0,0,0,.9);

    & .box {
      position: absolute;
      left: -25px;
      top: 8px;
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 2px;

    }
  }
}
</style>
